export type VideoItem = {
  id: string
  title: string
  productTypes?: string[]
}

export const ALL_VIDEOS: VideoItem[] = [
  {
    id: 'XMHqqTGjzvI',
    title: 'Z-Pile HR®',
    productTypes: ['Z-Pile HR', 'Z-Pile CF'],
  },
  {
    id: 'TJe_3HEa_IM',
    title: 'Z-Pile HR® | Z-Pile CF®',
    productTypes: ['Z-Pile HR', 'Z-Pile CF'],
  },
  {
    id: '34oVfUKPd4E',
    title: 'O-Pile®',
    productTypes: ['O-Pile'],
  },
  {
    id: 'Xxr__1q2vYg',
    title: 'PilePro® Connectors',
  },
  {
    id: 'xM6CQ0w4c-s',
    title: 'PilePro® Connectors Installation',
  },
]

export const getVideosForProductType = (productType: string): VideoItem[] => {
  return ALL_VIDEOS.filter((v) => v.productTypes?.includes(productType))
}
